// Browser-side logger shim. Same shape as backend's src/utils/logger so the
// mental model is identical across services. Centralizing here so a future
// swap (pino-browser, datadog-browser-logs, sentry breadcrumbs, etc.) doesn't
// require touching every callsite.
//
// Debug calls are silenced in production builds (REACT_APP_NODE_ENV==="production").

type LogFn = (message: unknown, ...meta: unknown[]) => void;

const isProd = process.env.NODE_ENV === "production" || process.env.REACT_APP_NODE_ENV === "production";

const ts = (): string => new Date().toISOString();

const logger: {
  info: LogFn;
  warn: LogFn;
  error: LogFn;
  debug: LogFn;
} = {
  info: (message, ...meta) =>
    // eslint-disable-next-line no-console
    console.log(`[${ts()}] INFO `, message, ...meta),
  warn: (message, ...meta) =>
    // eslint-disable-next-line no-console
    console.warn(`[${ts()}] WARN `, message, ...meta),
  error: (message, ...meta) =>
    // eslint-disable-next-line no-console
    console.error(`[${ts()}] ERROR`, message, ...meta),
  debug: (message, ...meta) => {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log(`[${ts()}] DEBUG`, message, ...meta);
    }
  },
};

export default logger;
